/**
 * Quality scorecard thresholds for determining tool health
 */

export const QUALITY_THRESHOLDS = {
  /**
   * P90 loading time threshold in milliseconds
   * Below this value is considered "good" performance
   */
  P90_LOADING_TIME_MS: 3000,

  /**
   * Views with errors percentage threshold
   * Below this value is considered "good" reliability
   */
  VIEWS_WITH_ERRORS_PERCENTAGE: 5,
} as const

/**
 * Check if a P90 loading time is considered good
 * @param p90LoadingTime - P90 loading time in milliseconds
 * @returns true if the loading time is below the threshold
 */
export const isGoodLoadingTime = (p90LoadingTime?: number): boolean => {
  if (p90LoadingTime === undefined) return false
  return p90LoadingTime < QUALITY_THRESHOLDS.P90_LOADING_TIME_MS
}

/**
 * Check if the error rate is considered good
 * @param viewsWithErrorsPercentage - Percentage of views with errors
 * @returns true if the error rate is below the threshold
 */
export const isGoodReliability = (viewsWithErrorsPercentage?: number): boolean => {
  if (viewsWithErrorsPercentage === undefined) return false
  return viewsWithErrorsPercentage < QUALITY_THRESHOLDS.VIEWS_WITH_ERRORS_PERCENTAGE
}

/**
 * Calculate reliability percentage (inverse of error percentage)
 * @param viewsWithErrorsPercentage - Percentage of views with errors
 * @returns Reliability percentage (0-100)
 */
export const calculateReliabilityPercentage = (viewsWithErrorsPercentage?: number): number => {
  if (viewsWithErrorsPercentage === undefined) return 0
  return 100 - viewsWithErrorsPercentage
}
